import React, { useEffect, useState } from 'react'
import './PaymentDetails.css'
import { Button, RadioButton } from 'unified-ui-components-library'
import { checkkmark, initialPaymentIcn, renewalPaymentIcn } from '../../../images/TeleBindingImages/TeleBindingImages';
import { getApiData } from '../../../api/api';
import AxiosRequest from '../../../utils/axios';
import { useHistory} from 'react-router-dom/cjs/react-router-dom';
import DotsLoader from '../../Loader/DotsLoader/DotsLoader';
import { API_CONSTANTS, CAPS_Y, PAYMENT_STATUS, PAYMENT_TYPE, ROUTES, TELEBINDING_STAGES } from '../../../utils/constants';
import { set } from 'lodash';
import { decryptedData, getConfigFromStroage } from '../../../utils/getUrlsFromAws';
import { isAfter } from 'date-fns';

const axios = new AxiosRequest().getClient();

const PaymentDetails = () => {
  const router = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [renewalStatus, setRenewalStatus] = useState(sessionStorage.getItem("renewalStatusOnOtp"));
  const [initialStatus, setInitialStatus] = useState(sessionStorage.getItem("initialStatusOnOtp"));


  const checkPaymentStatus = async (paymentType, isAfterPayment = false) => {
    setIsLoading(true);
    try {
      const { url, body } = getApiData("tbUnifiedPaymentStatus");

      body.request.payload = {
        transactionId: localStorage.getItem("posvRefNumber"),
        paymentType: paymentType.toLowerCase(),
        agentId: localStorage.getItem("agntId"),
        redirectUrl: "",
        triggeredFor: paymentType.toLowerCase(),
        statusApiCallRequired: false
      };
      if(isAfterPayment){
        body.request.payload.beforeTwoHours = CAPS_Y;
      }
      const response = await axios.post(url, body);

      const apiResponse = response?.data?.response;
      const payload = apiResponse?.payload

      
      const unifiedWebhook = payload?.unifiedWebHookRequests?.[0];
      const txnStatusDesc = unifiedWebhook?.txnStatusDesc;

      const msgCode = response?.data?.response?.msgInfo?.msgCode;

      console.log({ response, unifiedWebhook })

      if (msgCode === "200") {

        if ( paymentType === PAYMENT_TYPE.INITIAL) {
          if (txnStatusDesc === PAYMENT_STATUS.SUCCESS) {
            setInitialStatus(txnStatusDesc)
            setTimeout(() => {
            router.push('/thankyou');
          }, 2000);

          } else {
            setInitialStatus(txnStatusDesc);
            sessionStorage.setItem("initialStatusOnOtp", txnStatusDesc);
          }

        }else{
          setRenewalStatus(txnStatusDesc);
          sessionStorage.setItem("renewalStatusOnOtp", txnStatusDesc);
        }

      }
    } catch (error) {
      console.error("Error calling checkStatus API", error);
      setPaymentStatus(PAYMENT_STATUS.FAILED);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePaymentData = async (dataParam) => {
    setIsLoading(true);
    try {
      const decodedData = atob(dataParam);
      const jsonData = JSON.parse(decodedData);
      console.log({jsonData})
      setPaymentData(jsonData);
      const { resultStatus, paymentType } = jsonData;
    
      if(resultStatus === PAYMENT_STATUS.PENDING || resultStatus === PAYMENT_STATUS.SUCCESS){
        await checkPaymentStatus(paymentType?.toUpperCase(), true);
        return
      }

      if (paymentType?.toUpperCase() === PAYMENT_TYPE.INITIAL) {
        if (resultStatus === PAYMENT_STATUS.SUCCESS) {
          setTimeout(() => {
            router.push('/thankyou');
          }, 2000);
        } else {
          sessionStorage.setItem("initialStatusOnOtp", resultStatus);
          setInitialStatus(resultStatus);
        }

      } else {
        sessionStorage.setItem("renewalStatusOnOtp", resultStatus);
        setRenewalStatus(resultStatus);
      }

    } catch (err) {
      setRenewalStatus(PAYMENT_STATUS.PENDING);
      setInitialStatus(PAYMENT_STATUS.PENDING);
      console.error("Error parsing payment data", err);
    } finally {
      setIsLoading(false)
    }
  }; 

  const getRenewalAndPaymentStatus = async () => {
      setIsLoading(true);
      const teleBStage = sessionStorage.getItem("tbStageOnOtp");
      
    try{

      if (teleBStage === TELEBINDING_STAGES.PAYMENT_PROCESSING) {
        if (renewalStatus === PAYMENT_STATUS.PENDING) {
          const paymentType = PAYMENT_TYPE.RENEWAL;
          await checkPaymentStatus(paymentType, true);
        } 
        if (renewalStatus === PAYMENT_STATUS.SUCCESS && initialStatus === PAYMENT_STATUS.PENDING) {
          const paymentType = PAYMENT_TYPE.INITIAL;
          await checkPaymentStatus(paymentType, true);
        }
      } 
   }catch(err){
    console.log("Error fetching payment status", err);
    }finally{
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const dataParam = params.get("data");

    console.log({ dataParam: !dataParam });
    if (!dataParam) {
      getRenewalAndPaymentStatus();
    }else{
      handlePaymentData(dataParam);
    }

    //handlePaymentData(dataParam);
  }, []);

  const handlePayment = async (type) => {
    setIsLoading(true);
    const paymentType = type === PAYMENT_TYPE.RENEWAL ? PAYMENT_TYPE.RENEWAL : PAYMENT_TYPE.INITIAL;
    try {

      const { url, body } = getApiData("tbUnifiedPayment")
    
      const {url: callbackUrl} = getApiData(API_CONSTANTS.REDIRECT_URL)
      body.request.payload = {
        transactionId: localStorage.getItem("posvRefNumber"),
        agentId: localStorage.getItem("agntId"),
        channel: localStorage.getItem("channelName"),
        paymentType: paymentType.toLowerCase(),
        redirectUrl: callbackUrl,
      }

      const response = await axios.post(url, body);

      console.log({response});
      const msgCode = response?.data?.response?.msgInfo?.msgCode;
      const redirectUrl = response?.data?.response?.payload?.redirectUrl;

      console.log('redirecturl', redirectUrl)
      if (msgCode == "200") {
        // router.push(redirectUrl);
        window.location.href = redirectUrl;

      } else {

        console.log("Unable to generate payment URL. Please try again later.");
      }
    } catch (error) {
      console.error("Payment Error:", error);
      console.log("Something went wrong while initiating payment.", error);

    } finally {
      setIsLoading(false);
    }
  }

  if (isLoading) {
    return <DotsLoader msg={"Please wait..."} />
  }

  return (
    <>
      <div className='payment-details'>
        <div className='payment-details-content'>
          <div className="subHeadingWrapper">
            <h4>Payment Details</h4>
            <p>
              The amount mentioned below is the premium amount. Once the renewal payment is successfully set up, you can proceed with paying the initial premium amount.
            </p>
          </div>

          <div className='payment-data-container'>
            <div className='premium-amount'>
              <p>Premium Amount</p> <span><span className='rpe-symbl'>₹</span>{localStorage.getItem("premiumAmount")}</span>
            </div>
            <div className='renewal-payment-container'>

              <div className='renewal-payment-option'>
                <span id="circularImg">
                  <img src={renewalPaymentIcn} alt="rupee" className="union-img" />
                </span>
                <p>Renewal Payment Option/s</p>
              </div>
              <div className='enach-container'>
                <div className='enach-content'>
                  <RadioButton
                    checked
                    disabled
                    label="enach"
                    name="example1"
                    onChange={() => { }}
                    value='option1'
                  />
                </div>
                <div className='btn-wrapper'>
                  {renewalStatus === PAYMENT_STATUS.SUCCESS ? (<>
                    <img src={checkkmark} alt="Payment Successful" className="checkmark-icn" />
                    <p className="payment-status-text"> Setup Complete!</p>
                  </>)  : renewalStatus === PAYMENT_STATUS.PENDING ? (
                    <>
                      <p className="payment-status-text-pending-text">Payment Pending...</p>
                    </>
                  ) : (
                    <Button
                      ariaHidden
                      buttonType="secondary"
                      size="default"
                      onClick={() => handlePayment(PAYMENT_TYPE.RENEWAL)}
                    >
                      Set up renewal payment
                    </Button>
                  )}
                </div>
              </div>

            </div>
            <div className='renewal-payment-container'>
              <div className='renewal-payment-option'>
                <span id="circularImg">
                  <img src={initialPaymentIcn} alt="rupee" className="union-img" />
                </span>
                <p>Initial Payment Option/s</p>
              </div>

              <div className='enach-container'>
                <div className='enach-content'>
                  <RadioButton
                    checked
                    disabled
                    label="Online Payment"
                    name="example2"
                    onChange={() => { }}
                    value='option2'
                  />
                </div>
                <div className='btn-wrapper'>
                  {initialStatus === PAYMENT_STATUS.SUCCESS ? (<>
                    <img src={checkkmark} alt="Payment Successful" className="checkmark-icn" />
                    <p className="payment-status-text"> Payment Complete!</p>
                  </>)  : initialStatus === PAYMENT_STATUS.PENDING ? (
                    <>
                      <p className="payment-status-text-pending-text">Payment Pending...</p>
                    </>
                  ) : (
                    <Button
                      disabled={renewalStatus !== PAYMENT_STATUS.SUCCESS || (initialStatus === PAYMENT_STATUS.PENDING)}
                      buttonType="secondary"
                      size="default"
                      onClick={() => handlePayment(PAYMENT_TYPE.INITIAL)}
                    >
                      Pay Now
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>

        </div>
      </div>
    </>

  )
}

export default PaymentDetails